// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2sCfS0UlIURd4rN5kU4ygH"};